// extracted by mini-css-extract-plugin
module.exports = {"buttons_holder":"style_buttons_holder__1gV4z"};